import { useApiClient } from "@/hooks/useApiClient";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { type User } from "@/types/localstorage";
import { HttpStatusCode, isAxiosError } from "axios";
import { useContext } from "react";
import { userDataContext } from "@/hooks/useUserData";
import { SendToTrackingService } from "@/api/handlers/errors";
import type { CommercialReceptionBookViewPlan } from "@/types/commercialReceptionBookViewPlan";

interface UserMeResponse {
  id: number;
  firstName: string;
  lastName: string;
  isFree: boolean;
  isStaff: boolean;
  email: string;
  isReadOnly?: boolean;
  isSharable?: boolean;
  commercialReceptionBookViewPlan?: CommercialReceptionBookViewPlan;
  ssoPartnerIds?: number[];
}

interface UserMe {
  userMe: () => void;
}

export const useUserMe = (): UserMe => {
  const { apiClient } = useApiClient();
  const url = "/auth/users/me/";
  const [, setUser] = useLocalStorage<User | undefined>("user", undefined);
  const userData = useContext(userDataContext);
  const userMe = (): void => {
    apiClient
      .get<UserMeResponse>(url)
      .then((response) => {
        const user = {
          ...response.data,
          id: String(response.data.id),
          isSharable: response.data.isSharable ?? false,
          ssoPartnerIds: response.data.ssoPartnerIds ?? [],
        };
        setUser(user);
        userData.setUserData(user);
      })
      .catch((error): void => {
        if (
          isAxiosError(error) &&
          (error.response?.status ?? HttpStatusCode.InternalServerError) >=
            HttpStatusCode.InternalServerError
        ) {
          SendToTrackingService(error);
        }
        return undefined;
      });
  };

  return { userMe };
};
